import client from './client';
import type { Plan, Subscription } from '../types/subscription';

export async function getPlans(): Promise<Plan[]> {
  const { data } = await client.get('/plans');
  return data;
}

export async function getCurrentSubscription(): Promise<Subscription | null> {
  const { data } = await client.get('/subscriptions/current');
  return data;
}

export async function getSubscriptionHistory(): Promise<Subscription[]> {
  const { data } = await client.get('/subscriptions/history');
  return data || [];
}
